/**
 * @ngdoc object
 * @name main
 * @description
 *
 */
angular
    .module('festzelt-os.documents.main', [
        'ui.router',
        'festzelt-os.components',
        //'ngListView'
    ]);

require('./routes');

// Directives
require('./directives/documents/documents-directive');

// Factories
require('./factories/document-factory');

// Store
require('./store/document');



// WEBPACK FOOTER //
// ./src/app/pages/documents/main/main-module.js